import { Block } from './Block';

export interface VersionEvent {
  id: string;
  name: string;
  description?: string;
  lotIds: string[] | null; // null = tous les lots
  pointages: Record<string, boolean>; // lotId → pointé
}

export interface ChiffrageVersion {
  id: string;
  name: string;
  blocks: Block[];
  createdAt: Date;
  status: 'draft' | 'draft-old' | 'finalized';
  events: VersionEvent[];
}

export const createVersion = (name: string, blocks: Block[]): ChiffrageVersion => ({
  id: `v-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  name,
  blocks,
  createdAt: new Date(),
  status: 'draft',
  events: [],
});
